"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sumsubSdkOpenedSelector = exports.cieLinkSelector = exports.cieButtonSelector = exports.spidLinkSelector = exports.spidButtonSelector = exports.campagnaRiconoscimentoEffettuataSelector = exports.riconoscimentoRafforzatoAbilitatoSelector = exports.statoVerificaCampagnaRiconoscimentoSelector = exports.authTokenReinforcedAuthSelector = void 0;
const reselect_1 = require("reselect");
const reinforcedAuthReducer = (state) => state;
exports.authTokenReinforcedAuthSelector = (0, reselect_1.createSelector)(reinforcedAuthReducer, (state) => {
    return state.authToken;
});
exports.statoVerificaCampagnaRiconoscimentoSelector = (0, reselect_1.createSelector)(reinforcedAuthReducer, (state) => {
    return state.statoCampagnaRiconoscimento;
});
exports.riconoscimentoRafforzatoAbilitatoSelector = (0, reselect_1.createSelector)(reinforcedAuthReducer, (state) => {
    return state.checkRiconscimentoRafforzatoAbilitatoDispositiva;
});
exports.campagnaRiconoscimentoEffettuataSelector = (0, reselect_1.createSelector)(reinforcedAuthReducer, (state) => {
    return state.campagnaRiconoscimentoEffettuata;
});
exports.spidButtonSelector = (0, reselect_1.createSelector)(reinforcedAuthReducer, (state) => {
    return state.spidButton;
});
exports.spidLinkSelector = (0, reselect_1.createSelector)(reinforcedAuthReducer, (state) => {
    return state.spidLink;
});
exports.cieButtonSelector = (0, reselect_1.createSelector)(reinforcedAuthReducer, (state) => {
    return state.cieButton;
});
exports.cieLinkSelector = (0, reselect_1.createSelector)(reinforcedAuthReducer, (state) => {
    return state.cieLink;
});
exports.sumsubSdkOpenedSelector = (0, reselect_1.createSelector)(reinforcedAuthReducer, (state) => {
    return state.sumsubSdkOpened;
});
